import React from 'react';
import style from './standView.module.scss';
import CustomCarousel from '../../stands/viewStand/CustomCarousel';

const Full = ({makeEmbedLink, stand}) => {
  const {
    banner,
    fullUpLe,
    fullLogo,
    fullUp,
    fullUpRi,
    fullLoRi,
    fullFiRi,
    fullCe,
    fullLeVi
  } = style;

  return (
    <>
      <div className={`${banner} ${fullUpLe}`}>
        {stand.upperLeftBanner && (
          <CustomCarousel images={stand.upperLeftBanner} alt="awdad" />
        )}
      </div>

      <div className={`${banner} ${fullLogo}`}>
        {stand.logos && (
          <CustomCarousel images={stand.logos} alt="awdad" />
        )}
      </div>

      <div className={`${banner} ${fullUp}`}>
        {stand.upperBanner && (
          <CustomCarousel images={stand.upperBanner} alt="awdad" />
        )}
      </div>

      <div className={`${banner} ${fullUpRi}`}>
        {stand.upperRightBanner && (
          <CustomCarousel images={stand.upperRightBanner} alt="awdad" />
        )}
      </div>

      <div className={`${banner} ${fullLoRi}`}>
        {stand.lowerRightBanner && (
          <CustomCarousel images={stand.lowerRightBanner} alt="awdad" />
        )}
      </div>

      <div className={`${banner} ${fullFiRi}`}>
        {stand.fixedRight && (
          <CustomCarousel images={stand.fixedRight} alt="awdad" />
        )}
      </div>

      <div className={fullCe}>
        <iframe
          src={`https://www.youtube.com/embed/${makeEmbedLink(
            stand.center?.[0] || '',
          )}?autoplay=1`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <div className={fullLeVi}>
        <iframe
          src={`https://www.youtube.com/embed/${makeEmbedLink(
            stand.leftVideo?.[0] || '',
          )}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </>
  );
};

export default Full;
